import React from 'react';
import { Paper, Typography, Box, Button } from '@mui/material';

export default function ErrorBlock({ message, onRetry }) {
  return (
    <Paper sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="h6" color="error" gutterBottom>
        {message || 'An error occurred'}
      </Typography>
      {onRetry && (
        <Box sx={{ mt: 1 }}>
          <Button variant="contained" onClick={onRetry}>Retry</Button>
        </Box>
      )}
    </Paper>
  );
}

